import PropTypes from 'prop-types';
/** @jsx jsx this comment is required for Storybook to render */
import { css, jsx } from '@emotion/core';
import { Heading2 } from '../../atoms/Headings/Headings';
import clientTile from '../../molecules/ClientTile/ClientTile';
import clientTileV1 from '../../molecules/ClientTileV1/ClientTileV1';
import statsTile from '../../molecules/StatsTile/StatsTile';
import singleTile from '../../molecules/SingleTile/SingleTile';
import Section from '../../molecules/Section/Section';
import ResponsiveContentWrapper from '../ResponsiveContentWrapper/ResponsiveContentWrapper';
import {
  colors,
  fontSizes,
  lineHeights,
  unitConverter as uc,
} from '../../../styles/base';
import { renderTileSections } from '../../templates/renderTileSections';

const ClientTileSection = ({
  clientTiles,
  columns,
  sectionHeading,
  sectionStyles,
}) => {
  const clientTileSectionGridCss = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  `;

  const heading2Css = css`
    flex-basis: 100%;
    margin: 0 auto ${uc('60px')};
    color: ${colors.darkGray.two};
    line-height: ${lineHeights.copy};
    text-align: center;
  `;

  const tileType = {
    clientTile,
    clientTileV1,
    statsTile,
    singleTile,
  };

  return (
    <Section sectionStyles={sectionStyles}>
      <ResponsiveContentWrapper>
        <div css={clientTileSectionGridCss}>
          {sectionHeading && (
            <Heading2 fontSize={fontSizes.thirty} css={heading2Css}>
              {sectionHeading}
            </Heading2>
          )}
          {renderTileSections(clientTiles, tileType, columns)}
        </div>
      </ResponsiveContentWrapper>
    </Section>
  );
};

ClientTileSection.propTypes = {
  sectionHeading: PropTypes.string,
  clientTiles: PropTypes.arrayOf(PropTypes.shape({})),
  sectionStyles: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  columns: PropTypes.number,
};

ClientTileSection.defaultProps = {
  sectionHeading: '',
  clientTiles: [],
  sectionStyles: {},
  columns: 3,
};

export default ClientTileSection;
